import { render, staticRenderFns } from "./ClassTabs.vue?vue&type=template&id=72be59e4&scoped=true&"
import script from "./ClassTabs.vue?vue&type=script&lang=js&"
export * from "./ClassTabs.vue?vue&type=script&lang=js&"
import style0 from "./ClassTabs.vue?vue&type=style&index=0&id=72be59e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be59e4",
  null
  
)

export default component.exports